import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TransactionSearchOperation } from "../../types";

type Props = {
  transactionSearchResult: TransactionSearchOperation;
};

function formatDateForm(dateString: string | undefined): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  const adjustedDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

  const day = String(adjustedDate.getUTCDate()).padStart(2, '0');
  const month = String(adjustedDate.getUTCMonth() + 1).padStart(2, '0');
  const year = adjustedDate.getUTCFullYear();

  return `${day}/${month}/${year}`;
}

const Summary = ({ transactionSearchResult }: Props) => {
  const { formatNumber, formatDate } = useIntl();
  useEffect(() => {
  }, [transactionSearchResult.transactionSearcherData]);

  return (
    <div className="column column-1">
      {transactionSearchResult.transactionSearcherData.length !== 0 ? (
        <aside>
          <div className="two-column">
            {!transactionSearchResult.transactionSearchRequest?.identifier && (
            <div>
              <span>
              <FormattedMessage id="summary.email"/>
              </span>
              <span>{transactionSearchResult.transactionSearcherData[0].email}</span>
            </div>
            )}
            <div>
              <span>
                <FormattedMessage id="summary.transactionDate"/>
              </span>
              <span>
                {formatDate(transactionSearchResult.transactionSearcherData[0].creationDate, {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                })}
              </span>
            </div>
            <div className="highlight">
              <span>
                <FormattedMessage id="summary.transactionAmount"/>
              </span>
              <span className="price">
                {formatNumber(Number(transactionSearchResult.transactionSearcherData[0].value), {
                  style: 'currency',
                  currency: transactionSearchResult.transactionSearcherData[0].currency,
                })}
              </span>
            </div>
          </div>
        </aside>
      ) : (
        <div>
          {transactionSearchResult.transactionSearchRequest?.identifier !== "" ? (
          <aside>
            <div className="two-column">
              <div>
                <span>
                  <FormattedMessage id="summary.identifier"/>
                </span>
                <span>
                  {transactionSearchResult.transactionSearchRequest?.identifier}
                </span>
              </div>
            </div>
          </aside>
          ) : (
            <aside>
              <div className="two-column">
                <div>
                  <span>
                    <FormattedMessage id="summary.email"/>
                  </span>
                  <span>{transactionSearchResult.transactionSearchRequest.email}</span>
                </div>
                <div>
                  <span>
                    <FormattedMessage id="summary.transactionDate"/>
                  </span>
                  <span>
                  {formatDateForm(transactionSearchResult.transactionSearchRequest.transactionDate)}
                  </span>
                </div>
                <div className="highlight">
                  <span>
                    <FormattedMessage id="summary.transactionAmount"/>
                  </span>
                  <span className="price">
                  {formatNumber(Number(transactionSearchResult.transactionSearchRequest.amount?.replace(/\./g, '').replace(',', '.')), {
                    style: 'currency',
                    currency: transactionSearchResult.transactionSearchRequest.currency,
                  })}
                  </span>
                </div>
              </div>
          </aside>)}
        </div>
      )
      }
    </div>
  );
};

export default Summary;
